import {useState,useEffect} from 'react'
import {subscribe} from '@services/events'
import useRoot from './use-root'

let createEvent = null;
subscribe(document,'sections:create', e=>createEvent = e);

const rootWasCurrent = root => {
  const result = root.matches('.was-current *');
  return result;
};

export default function useSectionWasCurrent(){
  const root = useRoot();
  const [wasCurrent,setWasCurrent] = useState(false);

  useEffect(()=>{
    if(!root) return;

    if(createEvent){
      setWasCurrent(rootWasCurrent(root));
    }

    return subscribe(document,'sections:change sections:create',()=>{
      setWasCurrent(rootWasCurrent(root));
    });
  },[root,setWasCurrent]);

  return wasCurrent;
}
